import $ from 'jquery';
import Search from './search/driver';

export default function search() {
  new Search({
    form: 'search-form',
    prodId: 'form-preload-product',
    queryId: 'form-preload-query',
    docTypesId: 'form-preload-doc-types',
  });

  // VALIDATION
  $.validator.addMethod('validator-no-product', (value) => {
    const query = value.split(' ')
      .filter((v) => { return !! v; } )
      .map((v) => { return v.toLowerCase(); } );
    let product = $('.product-field option:selected');

    if (product) {
      product = product.text().toLowerCase().trim();
    } else {
      return true;
    }

    if (product === 'remdesivir') {
      return true; // other validation will handle
    }

    let isValid = true;
    query.forEach( (q) => {
      if (q.length < 4) return;

      if (product.indexOf(q) !== -1) {
        isValid = false;
      }
    });

    return isValid;
  }, 'Product name cannot be used as a keyword');

  $.validator.addMethod('validator-no-product-rem', (value) => {
    const query = value.split(' ')
      .filter((v) => { return !! v; } )
      .map((v) => { return v.toLowerCase(); } );
    let product = $('.product-field option:selected');

    if (product) {
      product = product.text().toLowerCase().trim();
    } else {
      return true;
    }

    let isValid = true;
    query.forEach( (q) => {
      if (q.length < 4) return;

      if (product.indexOf(q) !== -1) {
        isValid = false;
      }
    });

    return isValid;
  }, 'The term “remdesivir” cannot be used as a keyword');
}



// WEBPACK FOOTER //
// ./src/assets/js/project/search.js